import { JSONSchemaType } from "ajv";
import { ExpandedJSONSchema7 } from "am-tax-fe-core";

type FormData = JSONSchemaType<JSONSchemaType<ExpandedJSONSchema7>>;

export const removeEmptyProperties = (obj: FormData): FormData => {
    const result: Partial<FormData> = {};

    for (const key in obj) {
        if (
            // eslint-disable-next-line no-prototype-builtins
            obj.hasOwnProperty(key) &&
            obj[key] !== undefined &&
            obj[key] !== null &&
            obj[key] !== "" &&
            !(typeof obj[key] === "number" && isNaN(obj[key]))
        ) {
            result[key] = obj[key];
        }
    }

    return result as FormData;
};
